export function isCardContinueWatching(card){
  return card.progress && card.progress >= 5 && card.progress <= 90;
}

export function isCardFreemium(userType, card) {
  const currentDate = new Date();
  return (userType === 'free' || userType === 'pc') && card?.freemium?.activate && currentDate > new Date(card.freemium.freemium_period_start) && currentDate < new Date(card.freemium.freemium_period_end);
}

export async function setClassesCardsUserData({ type: userType, isPcClassicUser }, cards, cardsUserData) {
  if(!cardsUserData) {
    return cards;
  }

  const watchedIds = cardsUserData.watched ? Object.values(cardsUserData.watched).map((id) => +id) : null;
  const watchLaterIds = cardsUserData.watched_later ? Object.values(cardsUserData.watched_later).map((id) => +id) : null;
  const trendAllTimeIds = cardsUserData.trend.all_time ? cardsUserData.trend.all_time.map((id) => +id) : null;
  const accessMap = {
    guest: ['Free'],
    free: ['Free'],
    pc: isPcClassicUser ? ['Free', 'Standard'] : ['Free'],
    pcp: ['Free', 'Standard', 'Premium']
  };

  const adjustClassAccess = (access) => {
    if (isPcClassicUser) return access;
    if (access === 'Standard') return 'Premium';
    return access;
  }

  function getCardData(card) {
    return {
      ...card,
      watched: watchedIds ? watchedIds.includes(card.id) : false,
      watch_later: watchLaterIds ? watchLaterIds.includes(card.id) : false,
      has_access: accessMap[userType]?.includes(card.access),
      access: adjustClassAccess(card.access),
      progress: cardsUserData.progress[card.id] || null,
      forceRouting: true,
      trendAllTime: trendAllTimeIds ? trendAllTimeIds.includes(card.id) : false,
      freemiumCountdown: isCardFreemium(userType, card)
    };
  }

  return cards.map((card) => ({
    ...getCardData(card),
    series: card?.series?.map((card) => getCardData(card)) || []
  }));
}

export function setCoursesCardsUserData(userType, cards, type) {
  let cardsToSet = [...cards];
  if (type === 'challenges') {
    cardsToSet = cardsToSet.filter(card => card.meta_type.includes('Challenge'))
  }
  return cardsToSet.map((card) => ({
    ...card,
    freemiumCountdown: isCardFreemium(userType, card)
  }));
}
